import * as React from "react";
import {
  Button,
  Grid
} from "@mui/material";
import {FormInput, FormInputDate, Textarea} from "../../../domains/common/components/FormInput";
import {useContext, useEffect, useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {deleteParticipant, findSubjectWithInn} from "../participant";
import {Title4} from "../../../domains/common/components/Typography";
import {ButtonBase} from "../../../domains/common/components/Button";
import {dealData} from "../deal";
import {waitInputComplete} from "../../../fn";
import {INNInputWithSearch, RepsSearch, SearchRepresentativeWithInn} from "./SearchSubject";
import {INN_ORG_MAX_LENGTH, KPP_ORG_MAX_LENGTH, OGRN_ORG_MAX_LENGTH} from "../../../enums";
import {stateManager} from "../../../stateManager";
import {ParticipantsContext} from "./Participants";

/**
 * Форма ввода данных для Юридического лица
 * @param className
 * @param values
 * @param optionElements
 * @param onChange
 * @param onDelete
 * @returns {Element}
 * @constructor
 */
export function OrganizationForm({className, values, optionElements, onChange, onDelete, handleAddExistRep}) {
  const [participantIdx, setParticipantIdx] = useState(null);
  const [repsSelect, setRepsData] = RepsSearch({handleAddExistRep})
  const [deleteButton, setDeleteButton] = useState('');

  useEffect(() => {
    setParticipantIdx(dealData.participants.findIndex((item) => item.participantId === values.participantId))

    if (onDelete) {
      setDeleteButton(
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={9}></Grid>
          <Grid item xs={3}><ButtonBase variant="contained" startIcon={<DeleteIcon/>} size="small" color="error"
                                    onClick={async () => {
                                      const result = await deleteParticipant(values?.participantId);
                                      if (result.ok)
                                        onDelete ? onDelete() : void 0;
                                    }}>
            Удалить
          </ButtonBase></Grid>
        </Grid>);
    }
  }, []);

  const handleChange = waitInputComplete((e) => {
    onChange ? onChange() : void 0;

    const name = e.target.name;
    const value = e.target.value;

    if(name === 'inn')
      handleInnChange(value);

    const participant = dealData.participants[participantIdx];
    participant[name] = value;
  }, 300);

  const handleDatePick = (name, val) => {
    onChange ? onChange() : void 0;

    const participant = dealData.participants[participantIdx];
    participant[name] = val;
  }

  const handleInnChange = async (value) => {
    if(value?.length < INN_ORG_MAX_LENGTH)
      return;

    const result = await findSubjectWithInn(value)

    const data = result.map(item => ({
      key: item.rep_subject_id,
      value: `${item.rep_lastName} ${item.rep_firstName} ${item.rep_middleName || ''}`.trim()
    }));

    setRepsData(data);
  }

  return (
    <Grid container size={12} spacing={0}>
      <Grid item xs={6} spacing={1}>
        <Grid item xs={12} container spacing={2} sx={{height: "auto"}} alignItems="stretch">
          <Grid item xs={12}><Title4 title="Организация"/></Grid>
          <Grid item xs={12}><Textarea label="Наименование" className={className} name="name" multiline={true} rows={3} value={values?.name} onChange={handleChange}/></Grid>
          <Grid item xs={12}><FormInput label="ИНН" className={className} name="inn" inputProps={{ maxLength: INN_ORG_MAX_LENGTH }} value={values?.inn} onChange={handleChange}/></Grid>
          <Grid item xs={12}><FormInput label="КПП" className={className} name="kpp" inputProps={{ maxLength: KPP_ORG_MAX_LENGTH }} value={values?.kpp} onChange={handleChange}/></Grid>
          <Grid item xs={12}><FormInput label="ОГРН" className={className} name="ogrn" inputProps={{ maxLength: OGRN_ORG_MAX_LENGTH }} value={values?.ogrn} onChange={handleChange}/></Grid>
          <Grid item xs={12}><FormInputDate label="Дата регистрации" className={className} name="regDate" value={values?.regDate} onChange={(val) => handleDatePick('regDate', val)}/></Grid>
          <Grid item xs={12}><FormInput label="Телефон" className={className} name="phone" value={values?.phone} onChange={handleChange}/></Grid>
          <Grid item xs={12}><FormInput label="e-mail" className={className} name="email" onChange={handleChange} value={values?.email}/></Grid>
        </Grid>
      </Grid>
      <Grid item xs={6} sx={{height: 20}}>
        <Grid item xs={6} sx={{height: 43}}></Grid>
      </Grid>
      {optionElements}
      {deleteButton}
    </Grid>
  )
}